/** @format */

import { Component, computed, input, Signal } from '@angular/core';
import { CommonModule, ImageLoaderConfig } from '@angular/common';
import { ProcessedNonBundleProduct } from '@shared/data-access/interfaces';
import { OptimizedImageComponentModule } from '@shared/media/components';
import { HmfTextLinkComponent } from '@dsg-tech/homefield-angular';

@Component({
	selector: 'pdp-hybrid-pla-attribute-thumbnails',
	imports: [CommonModule, OptimizedImageComponentModule, HmfTextLinkComponent],
	templateUrl: './hybrid-pla-attribute-thumbnails.component.html',
	styleUrl: './hybrid-pla-attribute-thumbnails.component.scss'
})
export class HybridPlaAttributeThumbnailsComponent {
	readonly product = input.required<ProcessedNonBundleProduct>();
	readonly basePDPUrl = input.required<string>();

	readonly thumbnailImageConfigs: Signal<ImageLoaderConfig[]> = computed(() => {
		const product = this.product();

		const colorAttribute = product.definingAttributes.find(
			(attr) => attr.name.toLowerCase() === 'color'
		);

		if (!colorAttribute) {
			return [];
		}

		return colorAttribute.value
			.split('|')
			.slice(0, 4)
			.map((color) => ({
				src: product.partNumber,
				width: 32,
				height: 32,
				loaderParams: {
					swatchColor: color,
					fit: 'constrain'
				}
			}));
	});
}
